import { makeStyles } from '@material-ui/core/styles';
import LegendIcon from '@material-ui/icons/FiberManualRecord';
import React, { FC } from 'react';
import AppAlert from '../../Components/ui/alert/AppAlert';
import { AppText } from '../../Components/ui/text';
import { blue, green, grey, red, yellow } from '@material-ui/core/colors';

const PAYMENT_COLORS = {
  paid: green[200],
  hasUnsettledComplaints: red[200],
  hasOpenedComplaints: yellow[200],
  payable: blue[200],
  unpayable: grey[200],
} as const;

const useStyles = makeStyles(
  (theme) => ({
    legendElement: {
      display: 'inline-flex',
      flexWrap: 'wrap',
      marginRight: theme.spacing(2),
    },
  }),
  { name: 'PaymentsListLegend' },
);

const PaymentsListLegend: FC = () => {
  const classes = useStyles();
  return (
    <AppAlert title="Legenda" severity="info" style={{ backgroundColor: 'white' }}>
      <AppText className={classes.legendElement}>
        <LegendIcon style={{ color: PAYMENT_COLORS.paid }} />
        Pagato
      </AppText>
      <AppText className={classes.legendElement}>
        <LegendIcon style={{ color: PAYMENT_COLORS.hasUnsettledComplaints }} />
        Pagamento con reclami non risolti
      </AppText>
      <AppText className={classes.legendElement}>
        <LegendIcon style={{ color: PAYMENT_COLORS.hasOpenedComplaints }} />
        Pagamento con reclami aperti
      </AppText>
      <AppText className={classes.legendElement}>
        <LegendIcon style={{ color: PAYMENT_COLORS.payable }} />
        Pagabile
      </AppText>
      <AppText className={classes.legendElement}>
        <LegendIcon style={{ color: PAYMENT_COLORS.unpayable }} />
        Non pagabile
      </AppText>
    </AppAlert>
  );
};

export default PaymentsListLegend;
